var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineConvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.277 12.005c0-5.918 4.81-10.728 10.728-10.728s10.728 4.81 10.728 10.728-4.82 10.728-10.728 10.728c-5.918 0-10.728-4.81-10.728-10.728zm1.497 0c0 5.09 4.142 9.23 9.231 9.23 5.09 0 9.23-4.14 9.23-9.23 0-5.09-4.14-9.23-9.23-9.23-5.09 0-9.23 4.14-9.23 9.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.77 12.734 5.609 4.55a.753.753 0 0 1 0-1.058.753.753 0 0 1 1.057 0l6.896 6.906.01-2.735c0-.409.34-.748.749-.748.409-.03.748.34.748.748l-.01 4.54c0 .3-.18.58-.46.69a.748.748 0 0 1-.828-.16zM17.334 20.507l-6.895-6.905-.01 2.734c0 .409-.34.748-.749.748a.754.754 0 0 1-.748-.748l.01-4.54c0-.3.18-.58.459-.69.28-.119.598-.05.818.16l8.163 8.183c.29.29.29.769 0 1.058-.13.15-.33.22-.519.22a.74.74 0 0 1-.529-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineConvert);
export default __webpack_public_path__ + "static/media/vuesax-outline-convert.c23249451dbe56b37cb0a0794acd0393.svg";
export { ForwardRef as ReactComponent };